import { GRADES } from '../constants';

export default function GradeCircle({ grade, score, size=80 }) {
  const g = GRADES[grade] || GRADES["C"];
  return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:5, flexShrink:0 }}>
      <div style={{ width:size, height:size, borderRadius:"50%", background:g.bg, border:`2.5px solid ${g.border}`, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", boxShadow:`0 0 20px ${g.color}30` }}>
        <span style={{ fontSize:size*0.42, fontWeight:900, color:g.color, lineHeight:1, fontFamily:"'Cinzel',serif" }}>{grade}</span>
        <span style={{ fontSize:size*0.13, color:g.color, opacity:0.7, fontWeight:700 }}>{score}/100</span>
      </div>
      <span style={{ fontSize:10, fontWeight:700, color:g.color, textAlign:"center" }}>{g.label}</span>
    </div>
  );
}
